import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Ellipsis} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$cc(Ellipsis, {
            'style': {width: '50px'},
            'hoverable': true,
            'children': 'hoverable'
        })
    ), 2 /* HasVNodeChildren */);
};